const actions = {
  CREATE_SAVED_SEARCH_REQUEST: 'CREATE_SAVED_SEARCH_REQUEST',
  CREATE_SAVED_SEARCH_SUCCESS: 'CREATE_SAVED_SEARCH_SUCCESS',
  DELETE_SAVED_SEARCH_REQUEST: 'DELETE_SAVED_SEARCH_REQUEST',
  DELETE_SAVED_SEARCH_SUCCESS: 'DELETE_SAVED_SEARCH_SUCCESS',

  createSavedSearch: data => ({
    type: actions.CREATE_SAVED_SEARCH_REQUEST,
    payload: data,
  }),

  createSavedSearchSuccess: data => ({
    type: actions.CREATE_SAVED_SEARCH_SUCCESS,
    payload: data,
  }),

  deleteSavedSearch: data => ({
    type: actions.DELETE_SAVED_SEARCH_REQUEST,
    payload: data,
  }),

  deleteSavedSearchSuccess: data => ({
    type: actions.DELETE_SAVED_SEARCH_SUCCESS,
    payload: data,
  }),
};
export default actions;
